(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-callout"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('campaign-content')) {
 customElements.define('campaign-content',class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.observer?.disconnect(); this.abort=new AbortController();
   const options={signal:this.abort.signal};
   if (this.dataset.animate==='true' && this.dataset.editor!=='true' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    this.classList.add('cc-ready');
    this.observer=new IntersectionObserver((entries)=>{ if(entries.some(entry=>entry.isIntersecting)){this.classList.add('cc-seen');this.observer.disconnect();} },{threshold:0.05});
    this.observer.observe(this);
   }
   this.addEventListener('focusin',()=>{this.classList.add('cc-seen');this.observer?.disconnect();},options);
   this.closest('.shopify-section')?.addEventListener('shopify:block:select',(event)=>{
    this.classList.add('cc-seen');this.observer?.disconnect();
    const details=Array.from(this.querySelectorAll('details[data-block-id]')).find(el=>el.dataset.blockId===event.detail.blockId);
    if(details)details.open=true;
   },options);
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.classList.remove('cc-ready');}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('campaign-content')) {
 customElements.define('campaign-content',class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.observer?.disconnect(); this.abort=new AbortController();
   const options={signal:this.abort.signal};
   if (this.dataset.animate==='true' && this.dataset.editor!=='true' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    this.classList.add('cc-ready');
    this.observer=new IntersectionObserver((entries)=>{ if(entries.some(entry=>entry.isIntersecting)){this.classList.add('cc-seen');this.observer.disconnect();} },{threshold:0.05});
    this.observer.observe(this);
   }
   this.addEventListener('focusin',()=>{this.classList.add('cc-seen');this.observer?.disconnect();},options);
   this.closest('.shopify-section')?.addEventListener('shopify:block:select',(event)=>{
    this.classList.add('cc-seen');this.observer?.disconnect();
    const details=Array.from(this.querySelectorAll('details[data-block-id]')).find(el=>el.dataset.blockId===event.detail.blockId);
    if(details)details.open=true;
   },options);
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.classList.remove('cc-ready');}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-introduction"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('campaign-content')) {
 customElements.define('campaign-content',class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.observer?.disconnect(); this.abort=new AbortController();
   const options={signal:this.abort.signal};
   if (this.dataset.animate==='true' && this.dataset.editor!=='true' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    this.classList.add('cc-ready');
    this.observer=new IntersectionObserver((entries)=>{ if(entries.some(entry=>entry.isIntersecting)){this.classList.add('cc-seen');this.observer.disconnect();} },{threshold:0.05});
    this.observer.observe(this);
   }
   this.addEventListener('focusin',()=>{this.classList.add('cc-seen');this.observer?.disconnect();},options);
   this.closest('.shopify-section')?.addEventListener('shopify:block:select',(event)=>{
    this.classList.add('cc-seen');this.observer?.disconnect();
    const details=Array.from(this.querySelectorAll('details[data-block-id]')).find(el=>el.dataset.blockId===event.detail.blockId);
    if(details)details.open=true;
   },options);
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.classList.remove('cc-ready');}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-navigation')) {
    customElements.define('campaign-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.menu = this.querySelector('details');
        this.summary = this.menu?.querySelector('summary');
        this.previousHeight = document.documentElement.style.getPropertyValue('--campaign-nav-height');
        this.resize = new ResizeObserver(() => {
          if (this.dataset.sticky === 'true') {
            this.ownHeight = `${this.getBoundingClientRect().height}px`;
            document.documentElement.style.setProperty('--campaign-nav-height', this.ownHeight);
          }
          if (window.innerWidth >= Number(this.dataset.breakpoint) && this.menu) this.menu.open = false;
        });
        this.resize.observe(this);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.menu?.open) { this.menu.open = false; this.summary.focus(); }
        }, options);
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a');
          if (!link || !this.menu?.contains(link)) return;
          this.menu.open = false;
          const targetUrl = new URL(link.href, window.location.href);
          if (targetUrl.origin === location.origin && targetUrl.pathname === location.pathname && targetUrl.hash) {
            let target;
            try { target = document.getElementById(decodeURIComponent(targetUrl.hash.slice(1))); } catch (_) { return; }
            if (target) {
              const oldTabindex = target.getAttribute('tabindex');
              target.setAttribute('tabindex', '-1');
              target.focus({ preventScroll: true });
              target.addEventListener('blur', () => { if (oldTabindex === null) target.removeAttribute('tabindex'); else target.setAttribute('tabindex', oldTabindex); }, { once: true });
            }
          }
        }, options);
        document.addEventListener('click', (event) => { if (!this.contains(event.target) && this.menu) this.menu.open = false; }, options);
        this.closest('.shopify-section')?.addEventListener('shopify:block:select', (event) => {
          if (this.menu && window.innerWidth < Number(this.dataset.breakpoint)) this.menu.open = true;
        }, options);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        if (document.documentElement.style.getPropertyValue('--campaign-nav-height') === this.ownHeight) {
          if (this.previousHeight) document.documentElement.style.setProperty('--campaign-nav-height', this.previousHeight);
          else document.documentElement.style.removeProperty('--campaign-nav-height');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-spotlight"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('campaign-content')) {
 customElements.define('campaign-content',class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.observer?.disconnect(); this.abort=new AbortController();
   const options={signal:this.abort.signal};
   if (this.dataset.animate==='true' && this.dataset.editor!=='true' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    this.classList.add('cc-ready');
    this.observer=new IntersectionObserver((entries)=>{ if(entries.some(entry=>entry.isIntersecting)){this.classList.add('cc-seen');this.observer.disconnect();} },{threshold:0.05});
    this.observer.observe(this);
   }
   this.addEventListener('focusin',()=>{this.classList.add('cc-seen');this.observer?.disconnect();},options);
   this.closest('.shopify-section')?.addEventListener('shopify:block:select',(event)=>{
    this.classList.add('cc-seen');this.observer?.disconnect();
    const details=Array.from(this.querySelectorAll('details[data-block-id]')).find(el=>el.dataset.blockId===event.detail.blockId);
    if(details)details.open=true;
   },options);
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.classList.remove('cc-ready');}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('campaign-content')) {
 customElements.define('campaign-content',class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.observer?.disconnect(); this.abort=new AbortController();
   const options={signal:this.abort.signal};
   if (this.dataset.animate==='true' && this.dataset.editor!=='true' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    this.classList.add('cc-ready');
    this.observer=new IntersectionObserver((entries)=>{ if(entries.some(entry=>entry.isIntersecting)){this.classList.add('cc-seen');this.observer.disconnect();} },{threshold:0.05});
    this.observer.observe(this);
   }
   this.addEventListener('focusin',()=>{this.classList.add('cc-seen');this.observer?.disconnect();},options);
   this.closest('.shopify-section')?.addEventListener('shopify:block:select',(event)=>{
    this.classList.add('cc-seen');this.observer?.disconnect();
    const details=Array.from(this.querySelectorAll('details[data-block-id]')).find(el=>el.dataset.blockId===event.detail.blockId);
    if(details)details.open=true;
   },options);
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.classList.remove('cc-ready');}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-page-pro-controller')) {
    customElements.define('faq-page-pro-controller', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.cleanup?.();
      }
      initialize() {
    const root = this;
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const events = new AbortController();
    const timers = new Set();
    let revealObserver;
    const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal: events.signal });
    const later = (callback, delay) => {
      const id = window.setTimeout(() => { timers.delete(id); callback(); }, delay);
      timers.add(id);
      return id;
    };
    this.cleanup = () => {
      events.abort();
      timers.forEach((id) => window.clearTimeout(id));
      timers.clear();
      revealObserver?.disconnect();
      filterRun += 1;
      root.querySelectorAll('*').forEach((element) => element.getAnimations?.().forEach((animation) => animation.cancel()));
      delete root.dataset.initialized;
    };

    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const detailsList = items.map((item) => item.querySelector('[data-faq-details]')).filter(Boolean);
    const search = root.querySelector('[data-faq-search]');
    const clearSearch = root.querySelector('[data-faq-search-clear]');
    const filterButtons = Array.from(root.querySelectorAll('[data-faq-filters] [data-category]'));
    const categorySelect = root.querySelector('[data-faq-category-select]');
    const results = root.querySelector('[data-faq-results]');
    const empty = root.querySelector('[data-faq-empty]');
    const reset = root.querySelector('[data-faq-reset]');
    const grid = root.querySelector('[data-faq-grid]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const animateAccordion = root.dataset.motion !== 'none' && !reduceMotion;
    const duration = Number(root.dataset.duration) || 300;
    const easingMap = {
      smooth: 'cubic-bezier(.22, 1, .36, 1)',
      snappy: 'cubic-bezier(.2, .8, .2, 1)',
      standard: 'ease'
    };
    const easing = easingMap[root.dataset.easing] || easingMap.smooth;
    const filterMotion = root.dataset.filterMotion || 'fade-lift';
    const filterDuration = Number(root.dataset.filterDuration) || 360;
    const filterStagger = Number(root.dataset.filterStagger) || 0;
    const animateFilters = filterMotion !== 'none' && !reduceMotion && !designMode && Boolean(grid?.animate);
    let activeCategory = 'all';
    let filterRun = 0;
    let searchTimer = null;

    if (root.dataset.accordionMode === 'single') {
      let hasOpenItem = false;
      detailsList.forEach((details) => {
        if (!details.open) return;
        if (!hasOpenItem) {
          hasOpenItem = true;
        } else {
          details.open = false;
        }
      });
    }

    const normalize = (value = '') => value.toLowerCase().replace(/\s+/g, ' ').trim();

    const setOpen = (details, open, immediate = false) => {
      if (!details || details.open === open && !details.dataset.animating) return;
      details.dataset.targetOpen = String(open);
      const answer = details.querySelector('[data-faq-answer]');
      if (!answer) {
        details.open = open;
        return;
      }

      answer.getAnimations().forEach((animation) => animation.cancel());
      delete details.dataset.animating;

      if (immediate || !animateAccordion || !answer.animate) {
        details.open = open;
        answer.removeAttribute('style');
        return;
      }

      details.dataset.animating = 'true';

      if (open) {
        details.open = true;
        answer.style.overflow = 'hidden';
        const endHeight = answer.scrollHeight;
        const animation = answer.animate(
          [
            { height: '0px', opacity: 0 },
            { height: `${endHeight}px`, opacity: 1 }
          ],
          { duration, easing }
        );

        animation.onfinish = () => {
          answer.removeAttribute('style');
          delete details.dataset.animating;
        };
      } else {
        answer.style.overflow = 'hidden';
        const startHeight = answer.getBoundingClientRect().height;
        const animation = answer.animate(
          [
            { height: `${startHeight}px`, opacity: 1 },
            { height: '0px', opacity: 0 }
          ],
          { duration: Math.max(180, duration * .82), easing }
        );

        animation.onfinish = () => {
          details.open = false;
          answer.removeAttribute('style');
          delete details.dataset.animating;
        };
      }
    };

    const updateUrl = (details) => {
      if (root.dataset.updateUrl !== 'true' || !details.open) return;
      const item = details.closest('[data-faq-item]');
      if (!item?.id) return;
      history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${item.id}`);
    };

    detailsList.forEach((details) => {
      const summary = details.querySelector('[data-faq-summary]');
      if (!summary) return;

      listen(summary, 'click', (event) => {
        event.preventDefault();
        const opening = (details.dataset.targetOpen || String(details.open)) !== 'true';

        if (opening && root.dataset.accordionMode === 'single') {
          detailsList.forEach((other) => {
            if (other !== details && other.open) setOpen(other, false);
          });
        }

        setOpen(details, opening);
        if (opening) updateUrl(details);
      });
    });

    const updateFilterCounts = () => {
      if (categorySelect) categorySelect.replaceChildren();
      filterButtons.forEach((button) => {
        const key = button.dataset.category;
        const count = key === 'all'
          ? items.length
          : items.filter((item) => item.dataset.category === key).length;
        const countNode = button.querySelector('[data-filter-count]');
        if (countNode) countNode.textContent = count;
        if (categorySelect) {
          const name = button.querySelector('span')?.textContent.trim() || key;
          categorySelect.add(new Option(countNode ? `${name} (${count})` : name, key));
        }
      });
    };

    const filterFrames = (phase) => {
      if (filterMotion === 'fade') {
        return phase === 'out'
          ? [{ opacity: 1 }, { opacity: 0 }]
          : [{ opacity: 0 }, { opacity: 1 }];
      }

      if (filterMotion === 'soft-scale') {
        return phase === 'out'
          ? [{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.965)' }]
          : [{ opacity: 0, transform: 'scale(.965)' }, { opacity: 1, transform: 'scale(1)' }];
      }

      return phase === 'out'
        ? [{ opacity: 1, transform: 'translateY(0) scale(1)' }, { opacity: 0, transform: 'translateY(-10px) scale(.985)' }]
        : [{ opacity: 0, transform: 'translateY(14px) scale(.985)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }];
    };

    const stopFilterAnimation = (element) => {
      if (!element?._faqFilterAnimation) return;
      element._faqFilterAnimation.cancel();
      element._faqFilterAnimation = null;
      element.classList?.remove('is-filter-animating');
    };

    const playFilterAnimation = (element, keyframes, options) => {
      if (!element?.animate) return null;
      stopFilterAnimation(element);
      element.classList?.add('is-filter-animating');
      const animation = element.animate(keyframes, options);
      element._faqFilterAnimation = animation;
      const retainFinalFrame = options.fill === 'both' || options.fill === 'forwards';
      const cleanup = () => {
        if (element._faqFilterAnimation === animation) element._faqFilterAnimation = null;
        element.classList?.remove('is-filter-animating');
      };
      listen(animation, 'finish', () => {
        if (!retainFinalFrame) cleanup();
      }, { once: true });
      listen(animation, 'cancel', cleanup, { once: true });
      return animation;
    };

    const updateFilterUi = (query, visible) => {
      if (clearSearch) clearSearch.hidden = query.length === 0;
      if (empty) empty.hidden = visible !== 0;

      if (results) {
        const noun = visible === 1 ? root.dataset.resultSingular : root.dataset.resultPlural;
        results.textContent = `${root.dataset.resultsPrefix} ${visible} of ${items.length} ${noun}`;
      }
    };

    const applyFilters = async ({ animate = true } = {}) => {
      const run = ++filterRun;
      if (categorySelect) categorySelect.value = activeCategory;
      filterButtons.forEach((button) => {
        const active = button.dataset.category === activeCategory;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      stopFilterAnimation(grid);
      const query = normalize(search?.value || '');
      const words = query.split(' ').filter(Boolean);
      const visibility = new Map();
      let visible = 0;

      items.forEach((item) => {
        const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
        const haystack = normalize(item.dataset.search || '');
        const searchMatch = words.length === 0 || words.every((word) => haystack.includes(word));
        const show = categoryMatch && searchMatch;
        visibility.set(item, show);
        if (show) visible += 1;
      });

      updateFilterUi(query, visible);

      const shouldAnimate = animate && animateFilters && grid;
      if (!shouldAnimate) {
        items.forEach((item) => {
          stopFilterAnimation(item);
          const show = visibility.get(item);
          item.hidden = !show;
          if (!show) {
            const details = item.querySelector('[data-faq-details]');
            if (details?.open) setOpen(details, false, true);
          }
        });
        grid?.removeAttribute('aria-busy');
        return;
      }

      items.forEach(stopFilterAnimation);
      if (grid._faqFilterAnimation) {
        grid._faqFilterAnimation.cancel();
        grid._faqFilterAnimation = null;
      }

      const oldVisible = items.filter((item) => !item.hidden);
      const oldRects = new Map(oldVisible.map((item) => [item, item.getBoundingClientRect()]));
      const oldGridHeight = grid.getBoundingClientRect().height;
      const exiting = oldVisible.filter((item) => !visibility.get(item));
      grid.setAttribute('aria-busy', 'true');

      if (exiting.length) {
        const exitLength = Math.max(100, Math.round(filterDuration * .34));
        const exitAnimations = exiting.map((item, index) => {
          const animation = playFilterAnimation(item, filterFrames('out'), {
            duration: exitLength,
            delay: Math.min(index * 8, 48),
            easing,
            fill: 'both'
          });
          return animation?.finished.catch(() => null);
        }).filter(Boolean);
        await Promise.all(exitAnimations);
      }

      if (run !== filterRun) return;

      items.forEach((item) => {
        const show = visibility.get(item);
        item.hidden = !show;
        if (!show) {
          stopFilterAnimation(item);
          const details = item.querySelector('[data-faq-details]');
          if (details?.open) setOpen(details, false, true);
        }
      });

      void grid.offsetHeight;
      const newVisible = items.filter((item) => !item.hidden);
      const newGridHeight = grid.getBoundingClientRect().height;

      if (Math.abs(oldGridHeight - newGridHeight) > 1) {
        const gridAnimation = grid.animate(
          [{ height: `${oldGridHeight}px` }, { height: `${newGridHeight}px` }],
          { duration: filterDuration, easing }
        );
        grid._faqFilterAnimation = gridAnimation;
        const clearGridAnimation = () => {
          if (grid._faqFilterAnimation === gridAnimation) grid._faqFilterAnimation = null;
        };
        listen(gridAnimation, 'finish', clearGridAnimation, { once: true });
        listen(gridAnimation, 'cancel', clearGridAnimation, { once: true });
      }

      newVisible.forEach((item, index) => {
        const previousRect = oldRects.get(item);
        const nextRect = item.getBoundingClientRect();

        if (previousRect) {
          const deltaX = previousRect.left - nextRect.left;
          const deltaY = previousRect.top - nextRect.top;
          if (Math.abs(deltaX) > .5 || Math.abs(deltaY) > .5) {
            playFilterAnimation(
              item,
              [
                { transform: `translate(${deltaX}px, ${deltaY}px)`, opacity: .82 },
                { transform: 'translate(0, 0)', opacity: 1 }
              ],
              { duration: filterDuration, easing }
            );
          }
        } else {
          playFilterAnimation(item, filterFrames('in'), {
            duration: filterDuration,
            delay: Math.min(index * filterStagger, 180),
            easing
          });
        }
      });

      const finishDelay = filterDuration + Math.min(newVisible.length * filterStagger, 180) + 30;
      later(() => {
        if (run === filterRun) grid.removeAttribute('aria-busy');
      }, finishDelay);
    };

    filterButtons.forEach((button) => {
      listen(button, 'click', () => {
        activeCategory = button.dataset.category || 'all';
        filterButtons.forEach((other) => {
          const active = other === button;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        void applyFilters({ animate: true });
      });
    });

    listen(categorySelect, 'change', () => {
      activeCategory = categorySelect.value;
      window.clearTimeout(searchTimer);
      void applyFilters({ animate: true });
    });

    listen(search, 'input', () => {
      if (clearSearch) clearSearch.hidden = normalize(search.value).length === 0;
      window.clearTimeout(searchTimer);
      searchTimer = later(() => {
        void applyFilters({ animate: true });
      }, 110);
    });

    listen(clearSearch, 'click', () => {
      search.value = '';
      search.focus();
      window.clearTimeout(searchTimer);
      void applyFilters({ animate: true });
    });

    listen(reset, 'click', () => {
      if (search) search.value = '';
      activeCategory = 'all';
      filterButtons.forEach((button) => {
        const active = button.dataset.category === 'all';
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      window.clearTimeout(searchTimer);
      void applyFilters({ animate: true });
      search?.focus();
    });

    root.querySelectorAll('[data-copy-link]').forEach((button) => {
      listen(button, 'click', async () => {
        const target = button.dataset.target;
        const url = `${window.location.href.split('#')[0]}#${target}`;
        const label = button.querySelector('span');
        const original = root.dataset.copyLabel;

        try {
          await navigator.clipboard.writeText(url);
        } catch (error) {
          const textarea = document.createElement('textarea');
          textarea.value = url;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          let copied = false;
          try { copied = document.execCommand('copy'); } catch {}
          textarea.remove();
          button.focus({ preventScroll: true });
          if (!copied) return;
        }

        if (label) label.textContent = root.dataset.copiedLabel;
        later(() => {
          if (label) label.textContent = original;
        }, 1800);
      });
    });

    const openFromHash = () => {
      if (root.dataset.enableDeepLinks !== 'true' || !window.location.hash) return;
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      window.clearTimeout(searchTimer);
      const target = root.querySelector(`#${CSS.escape(id)}`);
      const details = target?.querySelector('[data-faq-details]');
      if (!details) return;

      activeCategory = 'all';
      if (search) search.value = '';
      filterButtons.forEach((button) => {
        const active = button.dataset.category === 'all';
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      void applyFilters({ animate: false });

      if (root.dataset.accordionMode === 'single') {
        detailsList.forEach((other) => {
          if (other !== details && other.open) setOpen(other, false, true);
        });
      }

      setOpen(details, true, true);
      later(() => target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }), 80);
    };

    const setupReveal = () => {
      if (designMode || root.classList.contains('faq-page-pro--reveal-none') || reduceMotion || !('IntersectionObserver' in window)) {
        root.classList.remove('is-reveal-ready');
        root.querySelectorAll('.faq-reveal').forEach((element) => element.classList.add('is-visible'));
        return;
      }

      root.classList.add('is-reveal-ready');
      const observer = revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: .12, rootMargin: '0px 0px -40px' });

      root.querySelectorAll('.faq-reveal').forEach((element) => observer.observe(element));
    };

    updateFilterCounts();
    void applyFilters({ animate: false });
    setupReveal();
    openFromHash();
    listen(window, 'hashchange', openFromHash);

    listen(document, 'shopify:block:select', (event) => {
      const item = event.target.closest?.('[data-faq-item]');
      if (!item || !root.contains(item)) return;

      if (search) search.value = '';
      activeCategory = 'all';
      filterButtons.forEach((button) => {
        const active = button.dataset.category === 'all';
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      window.clearTimeout(searchTimer);
      void applyFilters({ animate: false });

      root.classList.remove('is-reveal-ready');
      root.querySelectorAll('.faq-reveal').forEach((element) => element.classList.add('is-visible'));
      item.hidden = false;
      setOpen(item.querySelector('[data-faq-details]'), true, true);
      item.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this.closest('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      const height = `${this.header.offsetHeight}px`;
      if (document.documentElement.style.getPropertyValue('--header-height') !== height) {
        document.documentElement.style.setProperty('--header-height', height);
      }
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver?.disconnect();
      this.headerIntersectionObserver?.disconnect();
      window.clearTimeout(this.isScrolling);
    }
    createObserver() {
      this.headerIntersectionObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      this.headerIntersectionObserver.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-milk-schedule"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('farms-seasonal-schedule')) {
    customElements.define('farms-seasonal-schedule', class extends HTMLElement {
      connectedCallback() {
        this.dispose();
        this.events = new AbortController();
        this.onBlockSelect = (event) => {
          if (this.contains(event.target)) {
            const details = this.querySelector('.fss__schedule');
            if (details) details.open = true;
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect, { signal: this.events.signal });
        this.updateCurrent();
        this.frame = window.requestAnimationFrame(() => { this.updateCurrent(); this.openFromAnchor(); });
        window.addEventListener('hashchange', () => this.openFromAnchor(), { signal: this.events.signal });
        if (this.dataset.mode === 'auto') {
          this.timer = window.setInterval(() => this.updateCurrent(), 60000);
          document.addEventListener('visibilitychange', () => {
            if (!document.hidden) this.updateCurrent();
          }, { signal: this.events.signal });
        }
      }
      disconnectedCallback() { this.dispose(); }
      dispose() {
        if (this.events) this.events.abort();
        if (this.timer) window.clearInterval(this.timer);
        if (this.frame) window.cancelAnimationFrame(this.frame);
        this.frame = null;
        this.timer = null;
      }
      openFromAnchor() {
        let hash;
        try { hash = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
        if (!hash) return;
        const anchor = this.querySelector('[data-schedule-anchor]');
        const target = hash === this.id ? this : anchor && hash === anchor.id && document.getElementById(hash) === anchor ? anchor : null;
        if (!target) return;
        const details = this.querySelector('.fss__schedule');
        if (details) details.open = true;
        target.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
      updateCurrent() {
        let monthKey = null;
        if (this.dataset.mode === 'auto') {
          try {
            const parts = new Intl.DateTimeFormat('en-US', {
              timeZone: this.dataset.timezone, year: 'numeric', month: 'numeric'
            }).formatToParts(new Date());
            const year = Number(parts.find((part) => part.type === 'year').value);
            const month = Number(parts.find((part) => part.type === 'month').value);
            monthKey = year * 12 + month;
          } catch { monthKey = null; }
        }
        this.querySelectorAll('[data-flavor]').forEach((row) => {
          let current = false;
          if (this.dataset.mode !== 'off') {
            if (row.dataset.override === 'current') current = true;
            else if (this.dataset.mode === 'auto' && row.dataset.override !== 'not_current' && row.dataset.valid === 'true' && monthKey !== null) {
              current = monthKey >= Number(row.dataset.start) && monthKey <= Number(row.dataset.end);
            }
          }
          row.classList.toggle('is-current', current);
          const badge = row.querySelector('[data-current-badge]');
          if (badge) badge.hidden = !current;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signature-glass-bottle-header"] && !Shopify.designMode) return;
  try {
    
  class SignatureBottleStickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky && this.header) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;

      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', SignatureBottleStickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
